import { analog_bjt } from './analog_bjt';

export class nsvbcp53mtwg extends analog_bjt {}
